import { noop } from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { SDKEventTypes, sendSDKEvent } from '@bingads-webui-campaign-react/sdk-utils';

import { PMaxLiteLandingPageCore } from './landing-page-core';

const initSDK = () => {
  if (window.parent && window.parent !== window) {
    sendSDKEvent({
      type: SDKEventTypes.SDKPMaxLPReady,
    });
  }
};

export function PMaxLiteSDKLandingPageCore(props) {
  const { logger } = props;

  useEffect(() => {
    initSDK();
  }, []);

  return <PMaxLiteLandingPageCore logger={logger} />;
}

PMaxLiteSDKLandingPageCore.propTypes = {
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

PMaxLiteSDKLandingPageCore.defaultProps = {
  logger: {
    trace: noop,
  },
};

